import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RegularInvestmentPlanFacade } from "./regular-investment-plan.facade";

@NgModule({
    declarations: [],
    imports: [
        CommonModule
    ],
    providers: [
        RegularInvestmentPlanFacade
    ]
})

export class RegularInvestmentPlanModule { }